import React from 'react'
import { Radio, RadioGroup, Typography } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import theme from '@modul-connect/shared/theme'

export const RadioButtonSelector = ({
  onChange,
  options,
  labels = {}, 
  value,
  disabled
}) => {
  return (
    <RadioGroup
      aria-label="groupBy"
      name="groupBy"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      row
    >
      {Object?.keys(options)?.map(option => {
        const val = options[option]
        const labelText = labels[option] || val  

        return (
          <ThemeProvider key={option} theme={radio_theme}>
            <FormControlLabel
              label={
                <Typography style={{
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 500,
                  fontSize: '12px',
                  lineHeight: '15px',
                  textTransform: 'uppercase',
                  color: theme.colors.midDarkGrey
                }}>
                  {labelText}
                </Typography>
              }
              disabled={disabled}
              key={val}
              value={val}      
              control={<Radio color="default" />}
            />
          </ThemeProvider>
        )
      })}
    </RadioGroup>
  )
}

const radio_theme = createTheme({
  palette: {
    primary: {
      main: '#3A8643',
    },
  },
  typography: {
    fontSize: 12,
    fontWeight: 200,
    body1: {
      color: theme.colors.grey
    },
  }
})